import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [cartCount, setCartCount] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
      <div className="container mx-auto px-4 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* القائمة الرئيسية */}
          <div className="hidden lg:flex items-center gap-8">
            <Link to="/shop" className={`text-sm font-medium transition-colors ${isScrolled ? 'text-gray-700 hover:text-rose-400' : 'text-white hover:text-rose-200'}`}>
              المتجر
            </Link>
            <Link to="/skincare" className={`text-sm font-medium transition-colors ${isScrolled ? 'text-gray-700 hover:text-rose-400' : 'text-white hover:text-rose-200'}`}>
              العناية بالبشرة
            </Link>
            <Link to="/makeup" className={`text-sm font-medium transition-colors ${isScrolled ? 'text-gray-700 hover:text-rose-400' : 'text-white hover:text-rose-200'}`}>
              المكياج
            </Link>
            <Link to="/bodycare" className={`text-sm font-medium transition-colors ${isScrolled ? 'text-gray-700 hover:text-rose-400' : 'text-white hover:text-rose-200'}`}>
              العناية بالجسم
            </Link>
            <Link to="/blog" className={`text-sm font-medium transition-colors ${isScrolled ? 'text-gray-700 hover:text-rose-400' : 'text-white hover:text-rose-200'}`}>
              المدونة
            </Link>
            <Link to="/about" className={`text-sm font-medium transition-colors ${isScrolled ? 'text-gray-700 hover:text-rose-400' : 'text-white hover:text-rose-200'}`}>
              من نحن
            </Link>
            <Link to="/contact" className={`text-sm font-medium transition-colors ${isScrolled ? 'text-gray-700 hover:text-rose-400' : 'text-white hover:text-rose-200'}`}>
              تواصل معنا
            </Link>
          </div>

          {/* الشعار */}
          <Link to="/" className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/8f4b99b6f50522f57c0c4089909ec764/4dfdb1a34e845bad39d10d6fd0b0ed95.png" 
              alt="Rose Mist" 
              className="h-12 w-auto object-contain"
            />
          </Link>

          {/* الأيقونات */}
          <div className="flex items-center gap-4">
            <button className={`hidden lg:block transition-colors ${isScrolled ? 'text-gray-700 hover:text-rose-400' : 'text-white hover:text-rose-200'}`}>
              <i className="ri-search-line text-xl"></i>
            </button>
            <Link to="/account" className={`hidden lg:block transition-colors ${isScrolled ? 'text-gray-700 hover:text-rose-400' : 'text-white hover:text-rose-200'}`}>
              <i className="ri-user-line text-xl"></i>
            </Link>
            <Link to="/cart" className={`relative transition-colors ${isScrolled ? 'text-gray-700 hover:text-rose-400' : 'text-white hover:text-rose-200'}`}>
              <i className="ri-shopping-bag-line text-xl"></i>
              {cartCount > 0 && (
                <span className="absolute -top-2 -right-2 bg-rose-400 text-white text-xs w-5 h-5 flex items-center justify-center rounded-full">
                  {cartCount}
                </span>
              )}
            </Link>
            <button 
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className={`lg:hidden transition-colors ${isScrolled ? 'text-gray-700' : 'text-white'}`}
            >
              <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>
        </div>

        {/* القائمة المحمولة */}
        {isMenuOpen && (
          <div className="lg:hidden bg-white border-t border-gray-100 py-4">
            <Link to="/shop" className="block py-3 px-4 text-gray-700 hover:bg-rose-50 hover:text-rose-400 transition-colors">
              المتجر
            </Link>
            <Link to="/skincare" className="block py-3 px-4 text-gray-700 hover:bg-rose-50 hover:text-rose-400 transition-colors">
              العناية بالبشرة
            </Link>
            <Link to="/makeup" className="block py-3 px-4 text-gray-700 hover:bg-rose-50 hover:text-rose-400 transition-colors">
              المكياج
            </Link>
            <Link to="/bodycare" className="block py-3 px-4 text-gray-700 hover:bg-rose-50 hover:text-rose-400 transition-colors">
              العناية بالجسم
            </Link>
            <Link to="/blog" className="block py-3 px-4 text-gray-700 hover:bg-rose-50 hover:text-rose-400 transition-colors">
              المدونة
            </Link>
            <Link to="/about" className="block py-3 px-4 text-gray-700 hover:bg-rose-50 hover:text-rose-400 transition-colors">
              من نحن
            </Link>
            <Link to="/contact" className="block py-3 px-4 text-gray-700 hover:bg-rose-50 hover:text-rose-400 transition-colors">
              تواصل معنا
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
